import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { Grid, Form } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { LKIcon, LKButton } from 'loankeeper-common/components'
import { GridContainer } from 'shared/StyledComponents'
import FormField from 'shared/newFormElements'
import { getPending as getPendingFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import translate, { translateDialog } from './translate'
import { addToWatchlist, removeFromWatchList } from 'src/store/client'

const addClientToWatchlistFetcher = 'addClientToWatchlistFetcher'
const addClientToWatchlistModal = 'addClientToWatchlistModal'
const undoAddClientToWatchlistFetcher = 'undoAddClientToWatchlistFetcher'
const undoAddClientToWatchlistModal = 'undoAddClientToWatchlistModal'
const WATCHLIST_CLIENT_FORM = 'WATCHLIST_CLIENT_FORM'

const Textarea = styled(FormField)`
  max-height: 66px;
`

const LKButtonOkay = styled(LKButton)`
  width: 120px;
`

// TODO: could it be merged with LKModal.Confirmation?
const AddClientToWatchlistModal = flowRight(
  LKModalContainer(addClientToWatchlistModal),
  reduxForm({
    form: WATCHLIST_CLIENT_FORM,
    onSubmit: async ({ comment }, dispatch, { params: { ID, hash, onFinish } }) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: addClientToWatchlistFetcher,
      //     callApi: Client.addToWatchlist,
      //     callApiArgs: [ID, hash, comment],
      //     resolve: onFinish,
      //   }),
      // )

      dispatch(LKModalActions.close(addClientToWatchlistModal))

      //UPDATED API REQUEST client_oper_api page:watchlist
      const res = await dispatch(
        addToWatchlist({
          ClientID: ID,
          HashSum_ClientID_: hash,
          Comment: comment,
        }),
      )
      if (addToWatchlist.fulfilled.match(res)) {
        onFinish()
      } else if (addToWatchlist.rejected.match(res)) {
        dispatch(LKModalActions.openError(res.payload.message))
      }
    },
  }),
)(({ modalInstanceName, handleSubmit, invalid, submitting }) => (
  <LKModal
    name={modalInstanceName}
    heading={translate('MSG_CONFIRM')}
    size="xs"
    footer={
      <LKModal.Footer>
        <LKButtonOkay alias="ok" onClick={handleSubmit} disabled={invalid || submitting} loading={submitting}>
          {translateDialog('cmd_finish')}
        </LKButtonOkay>
        <LKModal.CancelButton text={translateDialog('cmd_cancel')} />
      </LKModal.Footer>
    }
  >
    <div className="u-flex u-alignCenter u-justifyCenter" style={{ minHeight: 55 }}>
      <LKIcon alias="question" style={{ marginRight: 5 }} />
      {translate('CONFIRM_CLIENT_WATCH')}
    </div>
    <Form onSubmit={handleSubmit}>
      <GridContainer>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <label htmlFor="watchlist-reason">{translate('PROMPT_WATCH')}</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginTop: 10 }}>
            <Grid.Column width={16}>
              <Textarea id="watchlist-reason" type="textarea" name="comment" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </Form>
  </LKModal>
))

const UndoAddClientToWatchlistModal = () => {
  const dispatch = useDispatch()

  async function handleConfirm({ ID, hash, onFinish }) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: undoAddClientToWatchlistFetcher,
    //     callApi: Client.undoAddToWatchlist,
    //     callApiArgs: [ID, hash],
    //     resolve: onFinish,
    //   }),
    // )

    //UPDATED API REQUEST client_oper_api page=watchlistundo
    const res = await dispatch(
      removeFromWatchList({
        ClientID: ID,
        HashSum_ClientID_: hash,
      }),
    )
    if (removeFromWatchList.fulfilled.match(res)) {
      onFinish()
    } else if (removeFromWatchList.rejected.match(res)) {
      LKModalActions.openError(res.payload.message)
    }
  }

  return <LKModal.Confirmation name={undoAddClientToWatchlistModal} onConfirm={handleConfirm} />
}

const ClientWatchlistModal = () => (
  <>
    <AddClientToWatchlistModal />
    <UndoAddClientToWatchlistModal />
  </>
)

export default ClientWatchlistModal

export const open = (ID, hash, watched, onFinish) =>
  watched === 0
    ? LKModalActions.open({ name: addClientToWatchlistModal, ID, hash, onFinish })
    : LKModalActions.openConfirmation(undoAddClientToWatchlistModal, {
        message: translate('CONFIRM_CLIENT_UNWATCH'),
        ID,
        hash,
        onFinish,
      })

export const getPending = (state) =>
  getPendingFetcher(addClientToWatchlistFetcher)(state) === true ||
  getPendingFetcher(undoAddClientToWatchlistFetcher)(state) === true
